import mui from '../../static/js/mui.min.js'
//服务器地址
var hostName = window.location.hostname; 
   
var pathName=window.location.pathname;        

var serverPortTp = window.location.port;

var gtSchemeTp = window.location.protocol;

var basePath = pathName.substring(0,pathName.substr(1).indexOf('/')+1);

export const url = gtSchemeTp+ "//" + hostName + ":"+ serverPortTp +"/"+"jfsc";
export const backurl = gtSchemeTp+ "//" + hostName + ":"+ serverPortTp;
export const commonPicUrl = 'https://apicdn.app.gtja.com/baishitong';

export const type="jhjfmob";

export function errorCheck(xhr, status, err){
	if(err.toString()){
		mui.alert('网络超时或系统繁忙，请稍后再试',' ', function() {});	
	}else{
		mui.alert('网络超时',' ', function() {});
	}
	
    console.log('获取区域信息:',xhr, status, err.toString());
    if(document.querySelectorAll('.commonloading')[0]){
    	document.querySelectorAll('.commonloading')[0].className+=" none";
    }
}
export function sucErrorCheck(result){
	if(result.code=="2"){
		// toLogin();
		return false;
	}
	mui.alert(result.msg,' ', function() {});
	if(document.querySelectorAll('.commonloading')[0]){
    	document.querySelectorAll('.commonloading')[0].className+=" none";
    }
}
//提示信息  并返回上一页
export function alertAndFunc(msg,callback){
	mui.alert(msg,' ', callback);
}
//提示信息
export  function alertMsg(msg){
	mui.alert(msg,' ', function() {});
}

export function toLogin(){
		
		let login_from = localStorage.getItem('login_from');
		//app登录地址
		if(login_from == 'wxweb'){
			window.location.href= 'https://jf.gtja.com/moblogin';
		}else{
			window.location.href=backurl+'/jhjfmob/';
			
		}
}
export function toStockAccountLogin(){
	let linkurl=encodeURIComponent(url+'/jhApi.do?method=jybLogin');
	window.location.href='gtjayyz://jumpfunc?funid=10018&islogin=2&needmobile=1&needbranchno=1&linkurl='+linkurl;
}

//获取地址参数
export function getUrlParam(key) {
    var url = window.location.search;
    var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
    var result = url.substr(1).match(reg);
    return result ? decodeURIComponent(result[2]) : null;
}




// WEBPACK FOOTER //
// ./src/common/url.js